import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import PricingSection1 from "../components/Pricing/PricingSection1/PricingSection1";
import SEO from "../components/SEO";

const Pricing = () => {
  return (
    <>
      <SEO slug="Pricing" />

      <Navbar />
      <PricingSection1 />
      <Footer />
    </>
  );
};

export default Pricing;
